// ! HANDLES PRODUCT IMAGE CHANGE BY SELECTED SWATCH
// When a swatch is switched the matching images will change in the media viewer

const gdcSwatches = () => document.querySelectorAll('.gdc-js-product-variant__swatch')
const gdcMedia = () => document.querySelectorAll('.gdc-media-reveal')
const isMobile = () => window.screen.width <= 767

function handleSelectedSwatch(e) {
  const _s = {
    foundMatch: false,
    selectedSwatch: e.target.value,
    swatchableMedia: document.querySelectorAll('[data-swatchable="true"]'),
    showMedia: (m) => m.classList.remove('hide'),
    hideMedia: (m) => m.classList.add('hide'),
    sliderMobile: () => document.querySelector('.gdc-media-slider-mobile'),
    hasMatchingMedia: (val1, val2) => val1 && val1.includes(val2),
    scrollToFirst: () => {
      _s.sliderMobile().scrollTo(0, 0)
      window.scrollBy(0, -350)
    },
  }

  _s.swatchableMedia.forEach((media) => {
    let mediaSwatchData = media.dataset.swatch

    if (_s.hasMatchingMedia(mediaSwatchData, _s.selectedSwatch)) {
      _s.foundMatch = true
      _s.showMedia(media)
    } else {
      _s.hideMedia(media)
    }
  })

  // If no matching images show first 2 images (in order of Shopify CMS product images)
  !_s.foundMatch && _s.showMedia(swatchableMedia[0]) && _s.showMedia(swatchableMedia[1])

  isMobile() && _s.scrollToFirst()
}

function handleMedia() {
  gdcMedia().forEach((m) => m.classList.add('reveal'))
}

function handleSwatches() {
  gdcSwatches().forEach((swatch) => {
    swatch.addEventListener('click', handleSelectedSwatch)
  })

  // Select first variant on page load to override theme repositioning
  //gdcSwatches()[0].click()
}

function handleMediaOrderBySelectedVariant() {
  gdcMedia() && handleMedia()
  gdcSwatches() && handleSwatches()
}

window.addEventListener('DOMContentLoaded', handleMediaOrderBySelectedVariant)

// ! HANDLE PRODUCT METAFIELD QUOTE

const productQuote = () => document.querySelector('.gdc-product-media-text-card')

function resizeSlide(slide) {
  productQuote().style.height = `${slide.offsetHeight}px`

  // Forced inline width to counter Safari not containing quote inside parent
  productQuote().style.minWidth = `${slide.offsetWidth}px`
  productQuote().style.maxWidth = `${slide.offsetWidth}px`
}

function handleQuoteSize() {
  const slides = document.querySelectorAll('.gdc-product-gallery-item')
  // get first slide that is not hidden from swatch switcher
  const slide = [...slides].find((slide) => !slide.classList.contains('hide'))

  productQuote() && resizeSlide(slide)
}

window.addEventListener('DOMContentLoaded', handleQuoteSize)
window.addEventListener('resize', handleQuoteSize)

// ! HANDLE VARIANT BASED BADGES BASED ON SELECTED VARIANT

const variantBadges = () => document.querySelectorAll('.gdc-variant-badge')
const isVariantURL = () => window.location.href.includes('variant=')
const showBadges = (elem) => elem.classList.add('active')
const hideBadges = (elem) => elem.classList.remove('active')
const badgeVariantID = (elem) => elem.dataset.variantId
const selectedVariantID = () => window.location.search.split('variant=')[1]

// function

function handleSelectedVariantBadges() {
  setTimeout(() => {
    isVariantURL() &&
      variantBadges().forEach((group) => {
        badgeVariantID(group) === selectedVariantID() ? showBadges(group) : hideBadges(group)
      })
  }, 100)
}

function handleVariantBadges() {
  const variantSelectors = document.querySelector('[gdc-js-variants]')
  const observer = new MutationObserver(handleSelectedVariantBadges)

  const config = { subtree: true, childList: true }
  observer.observe(variantSelectors, config)

  window.addEventListener('beforeunload', function (event) {
    observer.disconnect()
  })
}

window.addEventListener('DOMContentLoaded', handleVariantBadges)

document.querySelector(".gdc-media-slider-mobile").addEventListener('scroll', () => {
  document.documentElement.style.setProperty('--scrollinc',(document.querySelector(".gdc-media-slider-mobile").scrollLeft) / (document.querySelector(".gdc-media-slider-mobile").scrollWidth - document.querySelector(".gdc-media-slider-mobile").clientWidth));
}, false);